import React from 'react'
import NavBar from '../navBar/Navbar'
import UpdateInput from './UpdateInput'

function UpdateBoard() {
  return (
    <div>
        <NavBar />
        <UpdateInput />
    </div>
  )
}

export default UpdateBoard